import { useEffect } from 'react';

type UseMobileContentHighlightProps = {
  commentPanelOpened: boolean;
  isMobile: boolean;
};

export const useMobileContentHighlight = ({
  commentPanelOpened,
  isMobile,
}: UseMobileContentHighlightProps) => {
  useEffect(() => {
    if (commentPanelOpened) {
      if (
        sessionStorage.getItem('isCommentHighlightsOn') !== 'ON' &&
        sessionStorage.getItem('isCommentHighlightsOn') !== 'OFF' &&
        isMobile
      ) {
        sessionStorage.setItem('isCommentHighlightsOn', 'ON');
      }
    }
  }, [commentPanelOpened, isMobile]);
};
